import React from 'react';
export const StandaloneImage = ({ src, width, height, alt, style, }) => {
    return (React.createElement("img", { src: src, width: width, height: height, style: style, alt: alt }));
};
const ConfigContext = React.createContext({
    renderComments: true,
    wrapPlaceholders: false,
    implementations: { Image: StandaloneImage },
});
export const ConfigProvider = ConfigContext.Provider;
export const useConfig = () => React.useContext(ConfigContext);
//# sourceMappingURL=config-context.js.map